import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import {FormControl} from '@angular/forms';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';

declare interface option {
  id: any,
  name: string,
  surname?: string
};

@Component({
  selector: 'app-multiselect-autocomplete',
  templateUrl: './multiselect-autocomplete.component.html',
  styleUrls: ['./multiselect-autocomplete.component.css']
})

export class MultiselectAutocompleteComponent implements OnInit {

  myControl = new FormControl();
  // options: string[] = ['One', 'Two', 'Three'];
  filteredOptions: Observable<option[]>;

  public serachvalue = '';
  @Input() placeholder: string = 'Search rep';
  @Input() idsVlues: Array<any> = [];
  @Input() value: Array<option> = [];
  @Input() options: Array<option> = [
    { id: 0, name: 'Manzana' },
    { id: 1, name: 'Melón' },
    { id: 2, name: 'Sandia' },
    { id: 3, name: 'Papaya' },
    { id: 4, name: 'Guayaba' },
    { id: 5, name: 'Kiwi' }
  ];

  @Output() emit: EventEmitter<any> = new EventEmitter();

  public tmp;

  constructor() { }

  ngOnInit() {
    this.options.unshift({ id: 'All', name: 'Select All' })
    this.tmp = [...this.options];
    this.options = this.options.map( option => { return { id: option.id, name: option.surname ? `${option.name} ${option.surname}` : option.name} })
    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith<string | option>(''),
      map(value => typeof value === 'string' ? value : (value.name)),
      map(name => name ? this._filter(name) : this.options.slice())
    );
  }

  displayFn(option?: option): string | undefined {
    return option ? option.name : undefined;
  }

  private _filter(name: string): option[] {
    const filterValue = name.toLowerCase();

    return this.options.filter(option => option.name.toLowerCase().includes(filterValue));
  }

  add(opc_id) {
    const idx = this.idsVlues.indexOf(opc_id);

    if (idx !== -1) {
      this.idsVlues.splice(idx, 1);
    } else {
      this.idsVlues.push(opc_id);
    }
    this.value = this.tmp.filter( option => this.idsVlues.includes(option.id));
    this.emit.emit({value: this.value});
  }

  added(opc_id) {
    return this.idsVlues.includes(opc_id);
  }

  setValue(e) {
    if (e.id !== 'All') {
      this.add(e.id);
    } else {
      if ((this.options.length - 1) !== this.idsVlues.length) {
        this.idsVlues = this.tmp.map( r => {return r.id});
        this.idsVlues.shift();
      } else {
        this.idsVlues = [];
      }

      this.value = this.tmp.filter( option => this.idsVlues.includes(option.id));
      this.emit.emit({value: this.value});
    }
  }

}
